module.exports = __webpack_public_path__ + "img/ccent.6b0e3ede.jpg";